import React from 'react';
import { BsBell } from 'react-icons/bs';
import Logo from '../images/Nav-Logo.png';
import DurianLogo from '../images/durian-logo.png';
import { useNavigate } from 'react-router-dom';
import SettingsPopUp from './SettingsPopUp';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../features/user/userSlice';
import { signOut as amplifySignOut } from 'aws-amplify/auth';
import UserPool from '../UserPool';

const getDisplayName = (user) => {
  const info = user?.userInfo;
  const token = user?.user;

  // 1. userInfo first_name/last_name (from /UserInfo API)
  if (info?.first_name || info?.last_name) {
    return `${info.first_name || ''} ${info.last_name || ''}`.trim();
  }
  // 2. Token given_name/family_name (Google OAuth JWT)
  if (token?.given_name || token?.family_name) {
    return `${token.given_name || ''} ${token.family_name || ''}`.trim();
  }
  // 3. Token name field (Google OAuth JWT)
  if (token?.name) return token.name;
  // 4. userInfo user_name
  if (info?.user_name) return info.user_name;
  // 5. Token email as last resort
  if (token?.email) return token.email;
  return 'User';
};

const Navbar = ({ onHamburgerClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleSignOut = async () => {
    try {
      // Sign out from AWS Amplify (Google OAuth)
      await amplifySignOut({ global: true });
    } catch (error) {
      // User may not be signed in via OAuth, continue with sign out
    }

    try {
      // Sign out from Cognito User Pool (email/password)
      const cognitoUser = UserPool.getCurrentUser();
      if (cognitoUser) {
        cognitoUser.signOut();
      }
    } catch (error) {
      // Cognito sign out failed, continue with local cleanup
    }

    // Clear all localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('reference');

    // Clear Redux state
    dispatch(logout());

    // Navigate to login page
    navigate('/login');
  };

  return (
    <div className="top-0 z-50 flex justify-between items-center px-5 py-3 bg-primary-500 text-white sticky w-full ">
      {/* Hamburger for mobile */}
      <button
        className="block md:hidden mr-3 focus:outline-none"
        onClick={onHamburgerClick}
        aria-label="Open sidebar"
      >
        <svg
          width="28"
          height="28"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <div className="flex ">
        <div className="flex items-center w-64 gap-3">
          <img src={DurianLogo} alt="Durian Technologies" className="h-[45px]" style={{ filter: 'brightness(0) invert(1)' }} />
        </div>

        <div className="flex gap-5">
          <p>Hello, {getDisplayName(user)}</p>
        </div>
      </div>
      <div className="flex items-center gap-5">
        <BsBell size={25} />
        <SettingsPopUp />
        <button className="py-2 px-3 border rounded-full" onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Navbar;
